import { updatePlanAdoptionRate } from './updatePlanAdoptionRateThunk';
export default updatePlanAdoptionRate;
